import OffersampleImg from "../../assets/defaults/OffersSample.jpg";
import { useEffect, useState } from 'react';
import { RiyalImgBLK } from "../../components/common/RiyalImg";
import { ToastContainer } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
// import Cookies from 'js-cookie';
// import { apiFetch } from '../../hooks/apiFetch';
import SuccessErrorMsg from '../../utilities/SuccessErrorMsg';
// import { useLangUrl } from "../../utilities/useLangUrl";
import { useTranslation } from 'react-i18next';

export default function OffersDetails() {
    const { OfferId } = useParams()
    const [selectedOffer, setSelectedOffer] = useState("");
    const [loading] = useState(false);
    const { handleSubmit, formState: { errors }, setValue } = useForm();
    // const langUrl = useLangUrl();
    const [, setError] = useState(null);
    // const showOffer = selectedOffer?.data?.data
    const { t, i18n } = useTranslation();

    useEffect(() => {
        async function fetchLibrary() {
            try {
                const book = await fetch(`${process.env.REACT_APP_MASAR_API_URL}/offers/${OfferId}`, {
                    method: "GET",
                    headers: {
                        "accept": "*/*"
                    },
                    body: JSON.stringify()
                });
                const responseData = await book.json();
                setSelectedOffer(responseData?.data?.data);
            } catch (err) {
                setError(t("errorGetData"), err);
            }
        }

        fetchLibrary();
    }, [OfferId, t]);

    async function onSubmit(data) {
    }

    return (
        <div className="container mt-4">
            <div className="d-flex flex-column-reverse flex-md-row align-items-center justify-content-center">
                {/* Offer Details */}
                <div className="col-12 col-md-7 text-center text-md-start">
                    <h2 className="fw-bold mb-4">
                        {i18n.language === "ar" ? selectedOffer.nameAr : selectedOffer.nameEn}
                    </h2>
                    <div className="mb-3">
                        <h6 className="text-decoration-underline">{t("Details")}</h6>
                        <div className="ms-3">
                            <p>{i18n.language === "ar" ? selectedOffer.descriptionAr : selectedOffer.descriptionEn}</p>
                            <p className="text-decoration-none">
                                {t("PriceBefore")} : <span className="text-decoration-line-through text-secondary">{selectedOffer.originalPrice}
                                    <RiyalImgBLK />
                                </span>
                                <br />{t("PriceAfter")} : <span className="fw-bold">
                                    {selectedOffer.discountedPrice}
                                    <RiyalImgBLK />
                                </span>
                            </p>
                        </div>
                        <div>
                            <p className="text-decoration-none">
                                {t("OfferTill")} : <span className="">{selectedOffer.endDate}
                                </span>
                            </p>
                        </div>
                    </div>
                    {!loading ?
                        <form className='d-flex flex-column text-center col-6 col-md-3 mt-4' onSubmit={handleSubmit(onSubmit)}>
                            <button className="btn btn-masar btn-dark-orange mt-2"
                                value="1"
                                type="submit"
                                onClick={(e) => {
                                    setValue("status", e.target.value);
                                }}
                            >{t("addToCart")}</button>
                            <SuccessErrorMsg
                                ToastContainer={ToastContainer}
                            />
                            {errors.status && <p className="text-danger">{errors.status.message}</p>}
                        </form>

                        : <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>
                    }
                </div>
                {/* Offer Image */}
                <div className="col-12 col-md-5 mb-4 mb-md-0 d-flex justify-content-center">
                    <div className="background-white rounded-3 shadow-sm p-3">
                        <img
                            crossOrigin="anonymous"
                            src={selectedOffer.image ? selectedOffer.image : OffersampleImg}
                            alt={`Offer ${selectedOffer.id}`}
                            className="100 rounded-3 object-fit-contain" />
                    </div>
                </div>


            </div>
        </div>
    );

};